import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Dialog, FlatButton, MenuItem, RaisedButton, SelectField } from 'material-ui';
import RealCargoNameAutoComplete from 'components/common/RealCargoNameAutoComplete';
import CargoCategoryAutoComplete from 'components/common/CargoCategoryAutoComplete';
import styles from 'styles';
import api from 'services';
import UpdateRealCargoGazTable from './UpdateRealCargoGazTable';
import { checkIfUpdate } from './utils';
import { addNotification } from 'actions/notifications/notifications';

/**
 * 
 * @param {{
 *  open: boolean, 
 *  handleCloseDialog: Function, 
 *  item: import('./CargoEditorRow').Item,
 *  cargoTypes: any[],
 *  updateRowsRealCargoData: Function,
 * }} props 
 */
function UpdateRealCargoDialog({ addNotification, ...props }) {
    const { 
        open, handleCloseDialog, item, cargoTypes,
    } = props;

    /**
     * @type {[RealCargo, React.Dispatch<RealCargo>]} state
     */
    const [realCargo, setRealCargo] = useState(/**@type {RealCargo} */ ({}));

    /**
     * get real cargo data with gazetters
     * @param {string} realCargoId 
     */
    const getRealCargo = (realCargoId) => {
        api.getRealCargoNameWithGaz(realCargoId)
            .then((response) => {
                setRealCargo({
                    ...response.data,
                    isUpdate: false,
                });
            });
    };

    useEffect(() => {
        getRealCargo(item.realCargoId);
    }, []);

    const handleChangeDetail = (value) => {
        setRealCargo({
            ...realCargo,
            details: value,
            isUpdate: checkIfUpdate(realCargo, cargoTypes),
        });
    };

    const updateItem = (updatedItem) => {
        setRealCargo({
            ...updatedItem,
            isUpdate: checkIfUpdate(updatedItem, cargoTypes),
        });
    };

    const handleUpdateRealCargo = () => {
        api.updateCargoRealName(realCargo)
            .then((response) => {
                if (response.status === 200) {
                    addNotification({
                        title: 'Success',
                        message: 'Real cargo and gazetters updated successfully.',
                        level: 'success',
                        _id: new Date().getMilliseconds(),
                        autoDismiss: 10, 
                    });
                    getRealCargo(realCargo._id);
                    props.updateRowsRealCargoData(realCargo);
                } else {
                    addNotification({
                        title: 'Error',
                        message: 'Failed to upload real cargo',
                        level: 'error',
                        _id: new Date().getMilliseconds(),
                        autoDismiss: 20, 
                    });
                }
            });
    };

    return (
        <Dialog
            open={open}
            contentStyle={{ maxWidth: '1100px' }}
            actions={[
                <FlatButton
                    label="Cancel"
                    primary
                    onClick={() => handleCloseDialog()}
                />,
            ]}
            title={
                <div>
                    <span style={{ display: 'flex' }}>EDIT REAL CARGO NAME</span>
                    <span 
                        style={{ fontSize: '13px' }}
                    >“Cargo type” and “Details” chang es will update all the same Cargo Real Names: “Sunflower Pellets”
                    </span>
                </div>
            }
        >
            <div
                style={{ display: 'flex', gap: '24px', maxWidth: '1100px' }}
            >
                <RealCargoNameAutoComplete 
                    item={realCargo}
                    cargoTypes={cargoTypes}
                    _preventFirstSearch
                    updateItem={updateItem}
                    isAutoComplete={false}
                />
                <CargoCategoryAutoComplete 
                    item={realCargo}
                    cargoTypes={cargoTypes}
                    updateItem={updateItem}
                />
                <SelectField
                    style={{ ...styles.selectFieldCSS, width: '72px' }}
                    value={realCargo.details}
                    labelStyle={{ overflow: 'unset', fontSize: '16px' }}
                    onChange={(_e, _i, v) => handleChangeDetail(v)}
                    maxHeight={200}
                    autoWidth
                    floatingLabelText='Details'
                    iconStyle={{ width: '24px', height: '24px' }}
                    underlineDisabledStyle={{ borderBottom: '1px solid rgba(0,0,0,0.1)' }}
                >
                    {
                        [...new Array(15)]
                            .map((_un, i) => <MenuItem key={`details-${i}`} style={styles.menuItemCSS} value={i + 1} primaryText={i + 1} />)
                    }
                </SelectField>
                {
                    realCargo.isUpdate &&
                    <RaisedButton 
                        label='update'
                        onClick={handleUpdateRealCargo} 
                        style={{
                            alignSelf: 'center',
                            marginTop: '20px',
                        }}
                        primary
                    />
                }
            </div>
            {
                realCargo._id &&
                <UpdateRealCargoGazTable
                    gazetters={realCargo.gazetters || []}
                />
            }
        </Dialog>
    );
}

export default connect(
    null,
    dispatch => bindActionCreators(
        {
            addNotification,
        },
        dispatch,
    ),
)(UpdateRealCargoDialog);

/**
 * @typedef RealCargo
 * @property {string} _id
 * @property {string} [name]
 * @property {number} [details]
 * @property {Parent} [parent]
 * @property {[Gazetter] | []} gazetters
 * @property {boolean} [isUpdate]
 */

/**
 * @typedef Parent
 * @property {{ _id?: string, name?: string }} red
*/

/**
 * @typedef Gazetter
 * @property {string} _id
 * @property {string} value
 * @property {string} CargoCategory
 * @property {string} CargoCategoryName
 * @property {number} details
 * @property {string} realCargoId
 * @property {string} realCargoName
*/



// WEBPACK FOOTER //
// ./app/components/Cargoes/Assigners/UpdateRealCargoDialog.jsx